import React from "react";

const Option4 = () => {
  return <div>Option4</div>;
};

export default Option4;
